import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BrowserDetectorService } from '../../services/browser-detector.service';

@Component({
  selector: 'boi-device-info',
  templateUrl: './device-info.page.html'
})
export class DeviceInfoPage implements OnInit {
  public readonly infoList = new Map<string, string>();

  constructor(
    private readonly browserDetectorService: BrowserDetectorService,
    private readonly deviceService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.infoList.set(' 1. PhoneDevice:', `${this.browserDetectorService.isPhoneDevice()}`);
    this.infoList.set(' 2. TabletDevice:', `${this.browserDetectorService.isTabletDevice()}`);
    this.infoList.set(' 3. MobileDevice:', `${this.browserDetectorService.isMobileDevice()}`);
    this.infoList.set(' 4. AndroidDevice:', `${this.browserDetectorService.isAndroidDevice()}`);
    this.infoList.set(' 5. BrowserAllowed:', `${this.browserDetectorService.isBrowserAllowed()}`);
    this.infoList.set(' 6. MobileDeviceAllowed:', `${this.browserDetectorService.isMobileDeviceAllowed()}`);
    this.infoList.set(' 7. PhoneContextBlacklisted:', `${this.browserDetectorService.isPhoneContextBlacklisted()}`);

    const deviceInfo = this.deviceService.getDeviceInfo();

    this.infoList.set(' 8. User agent:', deviceInfo.userAgent);
    this.infoList.set(' 9. Browser:', deviceInfo.browser);
    this.infoList.set('10. Browser version:', deviceInfo.browser_version);
    this.infoList.set('11. Device:', deviceInfo.device);
    this.infoList.set('12. OS:', deviceInfo.os);
    this.infoList.set('13. OS version:', deviceInfo.os_version);

    const devicePixelRatio = window.devicePixelRatio;

    this.infoList.set('14. Pixel ratio:', `${window.screen.width * devicePixelRatio}`);
    this.infoList.set('15. Resolution width:', `${window.screen.width * devicePixelRatio}`);
    this.infoList.set('16. Resolution height:', `${window.screen.height * devicePixelRatio}`);
  }
}
